/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_3Inputs */

const en_mk_desktop_step_3 = /** @type {(inputs: Mk_Desktop_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the connection, then open Build`)
};

const id_mk_desktop_step_3 = /** @type {(inputs: Mk_Desktop_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan koneksi, lalu buka Bangun`)
};

/**
* | output |
* | --- |
* | "Start the connection, then open Build" |
*
* @param {Mk_Desktop_Step_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_3 = /** @type {((inputs?: Mk_Desktop_Step_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_3(inputs)
	return en_mk_desktop_step_3(inputs)
});